import * as React from 'react';
import classnames from '../../core/utils/classnames.tsx';

const LegendItem = ({
    className,
    children,
    color,
    ...props
}: React.ComponentPropsWithRef<'div'> & { color: string }) => {
    return (
        <div
            className={classnames('flex gap-2 items-center justify-center text-sm text-content-strong', className)}
            {...props}
        >
            <div
                className={classnames(
                    'w-3.5 h-3.5 bg-data-data1 rounded',
                    color === 'data1' && 'bg-data-data1',
                    color === 'data2' && 'bg-data-data2',
                    color === 'data3' && 'bg-data-data3',
                    color === 'data4' && 'bg-data-data4'
                )}
            />
            <div>{children}</div>
        </div>
    );
};

export default LegendItem;
